
import axios from "axios";

const getUserStatsTable = (hook) => {
    const token = localStorage.getItem('access_token');
    axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/exams/retrieve_statistics_table/`, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
    })
    .then((response) => {
    hook(response.data.statistics_array);
    })
    .catch((error) => {
    console.error("Error retrieving existing exam, maybe it doesn't exist:", error);
    });
};

export default getUserStatsTable;